<div ngClass="{{ inputStyle }}">
    <label
        [ngClass]="{ required: required }"
        *ngIf="label"
        for="{{ inputId }}"
        >{{ label }}</label
    >
    <textarea
        [attr.sera-read-only]="readOnly ? '' : null"
        [required]="required"
        rows="{{ rows }}"
        cols="{{ cols }}"
        [style]="style"
        [placeholder]="placeholder"
        pInputTextarea
        [disabled]="isDisabled"
        [readOnly]="readOnly"
        [(ngModel)]="value"
        (change)="inputChanged.emit(value)"></textarea>
</div>
